module.exports = __webpack_public_path__ + "static/media/icon-marker.666d531d.svg";